import React from 'react';
import { Link } from 'react-router-dom';
import { isMobileLayout } from '../utils/uiSettings';
import { shouldShowPage } from '../utils/permissionControl';
import OrthoNavStatus from './OrthoNavStatus';

// 与 App.js 相同：共用 uiSettings 的手机布局判断
const isMobile = isMobileLayout;

/**
 * 顶部导航栏（PC / 手机两套布局），自 App.js 原样迁出；
 * 状态仍由 App 持有，经 props 传入，渲染结果与交互不变。
 */
export default function AppMainNav({
  permTick,
  currentPage,
  setCurrentPage,
  user,
  handleLogout,
  dark,
  setDark,
  showTitle,
  toggleTitleBar,
  announcements,
  currentAnnouncementIndex,
}) {
  return (
    <nav className="main-nav">
      {/* PC端布局 */}
      {!isMobile() && (
        <>
          {/* 导航链接 */}
          <div className="nav-links" data-perm-tick={permTick}>
            <Link 
              to="/" 
              style={{ color: '#fff', fontWeight: 500 }}
              onClick={() => setCurrentPage('home')}
              className={currentPage === 'home' ? 'active' : ''}
            >
              首页
            </Link>
            {/* 指挥系统 - 仅登录且有权限时显示，未登录不可见 */}
            {shouldShowPage('指挥系统页面') && (
              <Link 
                to="/command" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('command')}
                className={currentPage === 'command' ? 'active' : ''}
              >
                指挥系统
              </Link>
            )}
            {/* 工具下载 - 根据访问控制设置显示，允许访客访问 */}
            {shouldShowPage('工具下载') && (
              <Link 
                to="/tools" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('tools')}
                className={currentPage === 'tools' ? 'active' : ''}
              >
                工具下载
              </Link>
            )}
            {/* 坐标转换 - 根据访问控制设置显示，允许访客访问 */}
            {shouldShowPage('坐标转换') && (
              <Link 
                to="/coordinate" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('coordinate')}
                className={currentPage === 'coordinate' ? 'active' : ''}
              >
                坐标转换
              </Link>
            )}
            {/* 救援推送 - 使用「救援推送」权限点 */}
            {shouldShowPage('救援推送') && (
              <Link 
                to="/rescue" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('rescue')}
                className={currentPage === 'rescue' ? 'active' : ''}
              >
                救援推送
              </Link>
            )}
            {/* 多窗口直播监控 - 根据权限控制显示 */}
            {shouldShowPage('多窗口直播监控') && (
              <Link 
                to="/live" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('live')}
                className={currentPage === 'live' ? 'active' : ''}
              >
                多窗口直播
              </Link>
            )}
            {/* 建模进度：紧挨最后一个导航链接，约两个字间距 */}
            <OrthoNavStatus />
          </div>
          
          {/* 用户认证区域 */}
          <div className="nav-auth">
            {user ? (
              <>
                <Link 
                  to="/user" 
                  style={{ 
                    color: '#fff', 
                    textDecoration: 'none', 
                    cursor: 'pointer',
                    fontWeight: '500',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  欢迎，{user.username}
                </Link>
                <button className="btn" onClick={handleLogout}>退出</button>
              </>
            ) : (
              <>
                <span style={{ color: '#fff', marginRight: '10px' }}>访客模式</span>
                <Link to="/login">登录</Link> / <Link to="/register">注册</Link>
              </>
            )}
            <button className="btn" onClick={() => setDark(d => !d)}>{dark ? '☀️ 浅色' : '🌙 深色'}</button>
            <button className="btn" onClick={toggleTitleBar}>
              {showTitle ? '隐藏标题栏' : '显示标题栏'}
            </button>
          </div>
        </>
      )}

      {/* 手机端布局 */}
      {isMobile() && (
        <>
          {/* 第一行：导航链接独占一行 */}
          <div className="nav-links-mobile" data-perm-tick={permTick}>
            <Link 
              to="/" 
              style={{ color: '#fff', fontWeight: 500 }}
              onClick={() => setCurrentPage('home')}
              className={currentPage === 'home' ? 'active' : ''}
            >
              首页
            </Link>
            {shouldShowPage('指挥系统页面') && (
              <Link 
                to="/command" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('command')}
                className={currentPage === 'command' ? 'active' : ''}
              >
                指挥系统
              </Link>
            )}
            {shouldShowPage('工具下载') && (
              <Link 
                to="/tools" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('tools')}
                className={currentPage === 'tools' ? 'active' : ''}
              >
                工具下载
              </Link>
            )}
            {shouldShowPage('坐标转换') && (
              <Link 
                to="/coordinate" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('coordinate')}
                className={currentPage === 'coordinate' ? 'active' : ''}
              >
                坐标转换
              </Link>
            )}
            {shouldShowPage('救援推送') && (
              <Link 
                to="/rescue" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('rescue')}
                className={currentPage === 'rescue' ? 'active' : ''}
              >
                救援推送
              </Link>
            )}
            {/* 与 PC 导航一致：有「多窗口直播监控」权限时显示 */}
            {shouldShowPage('多窗口直播监控') && (
              <Link 
                to="/live" 
                style={{ color: '#fff', fontWeight: 500 }}
                onClick={() => setCurrentPage('live')}
                className={currentPage === 'live' || currentPage === 'multi-window-live' ? 'active' : ''}
              >
                多窗口直播
              </Link>
            )}
          </div>

          {/* 第二行：公告和用户操作 */}
          <div className="nav-second-row-mobile">
            {/* 用户操作区域 - 右对齐，避免与公告重叠 */}
            <div className="nav-auth-mobile" style={{
              marginLeft: 'auto', // 确保靠右对齐
              paddingLeft: '10px', // 与公告保持距离
              display: 'flex',
              alignItems: 'center',
              gap: '2px',  // 按钮之间的间距
              flexShrink: 0
            }}>
              {user ? (
                <>
                  <Link 
                    to="/user" 
                    className="user-welcome" 
                    style={{ 
                      fontSize: '11px', 
                      color: '#fff', 
                      whiteSpace: 'nowrap',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      padding: '2px 4px',
                      borderRadius: '3px',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    欢迎，{user.username}
                  </Link>
                  <button className="btn-mobile" onClick={handleLogout} style={{ fontSize: '10px', padding: '2px 5px' }}>退出</button>
                </>
              ) : (
                <>
                  <span className="guest-mode" style={{ fontSize: '11px', color: '#fff' }}>访客</span>
                  <Link to="/login" className="btn-mobile" style={{ fontSize: '10px', padding: '2px 5px' }}>登录</Link>
                </>
              )}
              <button className="btn-mobile" onClick={() => setDark(d => !d)} style={{ fontSize: '10px', padding: '2px 3px' }}>
                {dark ? '☀️' : '🌙'}
              </button>
              <button className="btn-mobile" onClick={toggleTitleBar} style={{ fontSize: '10px', padding: '2px 5px' }}>
                {showTitle ? '隐藏' : '显示'}
              </button>
            </div>

            {/* 公告区域 - 显示在登录信息同一行的左边 */}
            <div className="announcement-area" style={{ 
              position: 'absolute',   // 绝对定位
              left: '1px',  // 左边距
              top: '50%',  // 垂直居中
              transform: 'translateY(-50%)', // 垂直居中
              width: '150px', // 固定宽度
              height: '22px', // 固定高度
              overflow: 'hidden',  // 隐藏溢出内容
              zIndex: 10 // 确保公告区域在其他内容之上
            }}>
              {announcements.length > 0 ? (
                <div style={{
                  // 外层固定背景容器
                  background: 'rgba(236, 241, 166, 0.68)',  // 公告背景色
                  padding: '1px 5px',  // 内边距
                  borderRadius: '4px',  // 圆角
                  width: '100%',  // 占满容器宽度
                  height: '100%',  // 占满容器高度
                  boxSizing: 'border-box',  // 包含内边距和边框的宽度
                  display: 'flex',  // 使用flex布局
                  alignItems: 'center',  // 垂直居中对齐
                  position: 'relative'  // 相对定位
                }}>
                  {/* 固定的公告图标 */}
                  <span style={{ 
                    marginRight: '4px',  // 右边距
                    flexShrink: 0,  // 不压缩
                    fontSize: '11px',  // 字体大小
                    color: '#fff'  // 字体颜色
                  }}>📢</span>
                  
                  {/* 文字滚动区域 - 固定位置 */}
                  <div style={{
                    flex: 1,
                    overflow: 'hidden', // 隐藏溢出内容
                    position: 'relative', // 相对定位
                    height: '14px', // 固定高度
                    display: 'flex',    // 使用flex布局
                    alignItems: 'center' // 垂直居中对齐  
                  }}>
                    {/* 跑马灯文字 */}
                    <div style={{
                      position: 'absolute', // 绝对定位
                      whiteSpace: 'nowrap', // 不换行
                      fontSize: '13px', // 字体大小
                  background: 'rgba(236, 241, 166, 0)',  // 公告文字背景色
                      color: '#ff0000', // 字体颜色
                      animation: 'marquee 20s linear infinite', // 跑马灯动画 - 固定速度
                      width: 'max-content' // 内容宽度
                    }}>
                      {announcements[currentAnnouncementIndex]?.title ? 
                        `${announcements[currentAnnouncementIndex].title}：${announcements[currentAnnouncementIndex].content}` : 
                        announcements[currentAnnouncementIndex]?.content || ''
                      }
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.7)', // 字体颜色
                  background: 'rgba(0,0,0,0.2)', // 背景色
                  padding: '2px 6px', // 内边距 
                  borderRadius: '4px', // 圆角
                  width: '100%', // 占满容器宽度
                  height: '100%', // 占满容器高度
                  display: 'flex', // 使用flex布局
                  alignItems: 'center', // 垂直居中对齐
                  boxSizing: 'border-box' // 包含内边距和边框的宽度
                }}>
                  <span>暂无公告</span>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </nav>
  );
}
